import * as React from 'react';
import * as Autocomplete from 'react-autocomplete';
import { uniqBy } from 'lodash';
import * as classNames from 'classnames';
import * as $ from 'jquery';

export default class extends React.Component<
  { onChange; value; id; items; fetchItems; label; onFocus; onBlur; onSelect },
  { descriptions; value }
> {
  constructor() {
    super();
    this.state = {
      value: null,
      descriptions: []
    };
  }

  render() {
    let { onChange, value, id, items = [], fetchItems, label, onFocus, onBlur, onSelect } = this.props;
    const hasNothingToShow =
      items.concat(this.state.descriptions).filter(item => item[label].toLowerCase().indexOf(value.toLowerCase()) > -1)
        .length === 0;
    if (((hasNothingToShow && value.length > 0) || value.length >= 2) && value !== this.state.value) {
      if (value.startsWith(this.state.value) && this.state.descriptions.length < 10) {
        // console.log('should not query');
      } else {
        fetchItems(value).then(descriptions => this.setState({ value, descriptions }));
      }
    }
    const showItems = uniqBy(items.concat(this.state.descriptions), x => (x as any).description);
    return (
      <Autocomplete
        items={showItems}
        shouldItemRender={(item, value) =>
          value.length > 0 && item && item[label] && item[label].toLowerCase().indexOf(value.toLowerCase()) > -1
        }
        getItemValue={item => item[label]}
        wrapperStyle={{ display: '' }}
        renderMenu={function(items, value, style) {
          return (
            <div
              className="collection"
              style={{
                ...this.menuStyle,
                minWidth: $('.zeroMargin').width() + 'px',
                margin: '1px',
                zIndex: '1',
                position: 'absolute',
                maxHeight: '300px'
              }}
              children={items}
            />
          );
        }}
        renderItem={(item, highlighted) => (
          <div key={item.id} className={classNames('collection-item ', { active: highlighted })}>
            {item[label]}
          </div>
        )}
        value={value}
        onChange={e => {
          value = e.target.value;
          onChange(e);
        }}
        inputProps={{
          className: 'zeroMargin validate',
          id,
          onFocus,
          onBlur
        }}
        onSelect={value => {
          onSelect(showItems.find(i => i[label] === value));
          onChange({ target: { value } });
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/expenses/update-expense/description.autocomplete.tsx